import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { BadgeComponent } from '../../../../../../osp-ui/components/misc/badge/badge.component';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'osp-notification-overlay-toggler',
  standalone: true,
  imports: [BadgeComponent, NgClass, RippleModule],
  templateUrl: './notification-overlay-toggler.component.html',
  styleUrls: ['./notification-overlay-toggler.component.scss', '../../topbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationOverlayTogglerComponent {
  $icon = input('', { alias: 'icon' });
  $amount = input<number | null>(null, { alias: 'amount' });
  onClick = output<MouseEvent>();
}
